import React, { Component } from 'react';
import './Steps.css';
import Tooltip from './Tooltip';

class Step5 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stepNumber: 5,
      fields: {
        relationship: '',
        education: '',
        occupation: '',
        lifestyleExpectations: ''
      },
    };
  }

  allFieldsFilled() {
    const emptyFields = Object.keys(this.state.fields).filter(field => (
      this.state.fields[field].length === 0
    ));
    return emptyFields.length === 0;
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;
    fields[name] = e.target.value;

    this.setState({ fields });
  }

  handleNext(e) {
    e.preventDefault();
    this.props.saveData(this.state.fields);
    this.props.proceed(this.state.stepNumber);
  }

  render() {
    return (
      <div className={`Step Step-container ${(this.props.active)?'active':''}`}>
        <div className="Step-title">
          More to know...
        </div>
        <ul className="steps">
          <li className="step-number done">1</li>
          <li className="step-number done">2</li>
          <li className="step-number done">3</li>
          <li className="step-number done">4</li>
          <li className="step-number done">5</li>
          <li className="step-number">6</li>
        </ul>
        <div className="field-container radio open">
          <div className="field-title">Relationship status:</div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="relationshipSingle" name="relationship" value="single" />
            <label className="col" htmlFor="relationshipSingle">Single</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="relationshipOpen" name="relationship" value="openRelationship" />
            <label className="col" htmlFor="relationshipOpen">Open relationship</label>
          </div>
        </div>
        <div className="field-container radio open">
          <div className="field-title">Education:</div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="educationHighSchool" name="education" value="highSchool" />
            <label className="col" htmlFor="educationHighSchool">High School</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="educationBachelor" name="education" value="bachelor" />
            <label className="col" htmlFor="educationBachelor">Bachelor</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="educationMaster" name="education" value="master" />
            <label className="col" htmlFor="educationMaster">Master</label>
          </div>
        </div>
        <div className="field-container text open">
          <div className="field-title">Your occupation:</div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="occupation" placeholder="Your occupation..." />
            </div>
          </div>
        </div>
        <div className="field-container radio open">
          <div className="field-title">Lifestyle {(this.props.fields.accountType === 'sugar_parent')?'Budget' : 'Expectation'}:
            {this.props.fields.accountType === 'sugar_baby' && <Tooltip icon="?"><p>The monthly budget your daddy/mama can provide.</p>
              <p>Moderate $5000 - $10,000 per month</p>
              <p>High &lt; $10,000 per month</p>
            </Tooltip>}
            {this.props.fields.accountType === 'sugar_parent' && <Tooltip icon="?"><p>Moderate &gt; $1 million net worth</p>
              <p>High &lt; $1 million or more net worth</p>
            </Tooltip>}
          </div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="lifestyleExpectationsNegotiable" name="lifestyleExpectations" value="negotiable" />
            <label className="col" htmlFor="lifestyleExpectationsNegotiable">Negotiable</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="lifestyleExpectationsModerate" name="lifestyleExpectations" value="moderate" />
            <label className="col" htmlFor="lifestyleExpectationsModerate">Moderate</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="lifestyleExpectationsHigh" name="lifestyleExpectations" value="high" />
            <label className="col" htmlFor="lifestyleExpectationsHigh">High</label>
          </div>
        </div>
        <div className="row button-container space-between">
          <button
            className="btn btn-primary"
            onClick={(e) => {e.preventDefault();this.props.back(this.state.stepNumber);}}
          >
            Back
          </button>
          <button
            className="btn btn-primary"
            disabled={!this.allFieldsFilled()}
            onClick={(e) => this.handleNext(e)}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default Step5;


// WEBPACK FOOTER //
// ./src/components/Step5.js